import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { SiteOpeningHoursForm } from '../../interfaces/customer-sites';
import { DayOfTheWeek } from '../../enums/day-of-week';
import flatMap from 'lodash/flatMap';
import { CustomerSitesOpeningTimesRowComponent } from './customer-sites-opening-times-row.component';
@Component({
  selector: 'customer-sites-opening-times',
  templateUrl: 'customer-sites-opening-times.component.html',
  styleUrls: ['customer-sites-opening-times.component.scss'],
})
export class CustomerSitesOpeningTimesComponent implements OnInit {
  @Input() public openingTimesForm: FormArray<FormGroup<SiteOpeningHoursForm>>;
  @Input() public disableFields: boolean = false;

  @ViewChildren('customer-sites-opening-times-row')
  rows: QueryList<CustomerSitesOpeningTimesRowComponent>;

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  public errors: string[] = [];

  public setErrors() {
    this.errors = [];

    if (this.hasAtLeastOneDayErrors()) {
      this.errors.push('Site should open on at least one day');
    }

    if (this.hasRequiredErrors()) {
      this.errors.push('Times are required for non-closed days');
    }

    this.errors.push(
      ...this.openingTimesForm.controls
        .filter((c) => c.invalid && c.controls.close.hasError('closeGreaterThanOpen'))
        .map((control, i) => {
          return `${DayOfTheWeek[control.controls.dayOfWeek.value].substring(
            0,
            3,
          )} - Close must be after Open`;
        }),
    );
  }

  public hasRequiredErrors(): boolean {
    return (
      flatMap(this.openingTimesForm.controls, (c) => c.controls).filter(
        (c) => c.open.hasError('required') || c.close.hasError('required'),
      ).length > 0
    );
  }

  public hasAtLeastOneDayErrors(): boolean {
    return this.openingTimesForm.hasError('requireAtLeastOneDayOpen');
  }

  ngOnInit(): void {
    this.setErrors();
    this.openingTimesForm.valueChanges.subscribe((f) => this.setErrors());
  }

  closeClick() {
    this.rows.forEach((x) => {
      x.closeControls();
    });
    setTimeout(() => this.onClose.emit(), 200);
  }
}
